<!--
  AI:
  Status: "in progress"
  Type: Page
  SubType: DetailPage
  Reason: Trace detail page layout. Renders the centralized page header,
          a presentational summary card, the reusable variable store matrix
          and the per-Logic counter widget. PrimeFlex + PrimeNG only — no
          custom CSS.
-->
<mvs-page-header></mvs-page-header>

<div class="grid p-3">

    <!-- Trace summary card -->
    <div class="col-12 mb-3">
        @if (trace) {
            <mvs-lg-flow-trace-summary [trace]="trace"></mvs-lg-flow-trace-summary>
        } @else {
            <div class="p-3 text-color-secondary">
                Trace wird geladen...
            </div>
        }
    </div>

    <!-- Variable store matrix — NOT gated on `trace` so the panel stays
         visible even if the header load is still in-flight or returns empty.
         Default-expanded on this page because the matrix IS the main
         content (unlike the flow-designer overlay where it's secondary). -->
    <div class="col-12 mb-3">
        <mvs-lg-flow-variable-store-panel
            [traceFlowInputs]="traceFlowInputs"
            [traceStepTraces]="traceStepTraces"
            [traceFlowOutputs]="traceFlowOutputs"
            [startExpanded]="true">
        </mvs-lg-flow-variable-store-panel>
    </div>

    <!-- Per-Logic counter widget -->
    <div class="col-12">
        @if (counterWidget) {
            <mvs-widget [widgetData]="counterWidget"></mvs-widget>
        }
    </div>

</div>
